const Strings = {
	GENERIC_ERROR: "Ocurrión un error y no se pudo completar el proceso"
};

export default Strings;
